export default "__VITE_ASSET__BPLiUD0k__"